import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPersonIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fill="#606060" d="M6.667 0a3.333 3.333 0 1 1 0 6.667 3.333 3.333 0 0 1 0-6.667m0 1.667a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333m0 5.833c2.225 0 6.666 1.108 6.666 3.333v2.5H0v-2.5C0 8.608 4.442 7.5 6.667 7.5m0 1.583c-2.475 0-5.084 1.217-5.084 1.75v.917H11.75v-.917c0-.533-2.608-1.75-5.083-1.75" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default SvgPersonIcon;